import logo from './profile.png';
import c1 from './c1.jpg';
import c2 from './c2.jpg';
import c3 from './c3.jpg';
import c4 from './c4.jpg';
import c5 from './c5.jpg';
import c6 from './c6.jpg';
import d1 from './d1.jpg';
import d2 from './d2.jpg';
import d3 from './d3.jpg';
import d4 from './d4.jpg';
import d5 from './d5.jpg';
import dandy_logo from './dandy-logo.png'
import a1 from './1.jpg';
import a2 from './1.jpg';
import a3 from './1.jpg';
import a4 from './1.jpg';
import a5 from './1.jpg';
import a6 from './1.jpg';
import left from './left.png';
import right from './right.png';
import facebook from './facebook.png';
import instagram from './instagram.png';
import youtube from './youtube.png';
import tiktok from './tiktok.png';
import main_logo from './mainLogo.png';
import sqr_logo from './logo.png';
import about_hero from './about_hero.jpg';
import mission from './mission.jpg';
import vission from './vission.jpg';
import logo_white from './logo_white.png';
import pricing_hero from './pricing_hero.jpg';
import priyantha_hero from './priyantha_hero.jpg';
import priyantha_hero2 from './priyantha_hero2.jpg';
import priyantha from './priyantha.jpg';
import gallery from './gallery.jpg';
import contact from './contact.jpg';
import why1 from './why1.jpg';
import why2 from './why2.jpg';
import why3 from './why3.jpg';
import why4 from './why4.jpg';
import why5 from './why5.jpg';
import why6 from './why6.jpg';
import location_pin from './pin.png';
import telephone from './telephone.png';
import email from './apple.png';
import t1 from './t1.jpg';
import t2 from './t2.jpg';
import t3 from './t3.jpg';
import t4 from './t4.jpg';
import e1 from './e1.jpg';
import e2 from './e2.jpg';
import e3 from './e3.jpg';
import e4 from './e4.jpg';
import e5 from './e5.jpg';

const Image = {
    a1,
    a2,
    a3,
    a4,
    a5,
    a6,
    logo,
    c1,
    c2,
    c3,
    c4,
    c5,
    c6,
    d1,
    d2,
    d3,
    d4,
    d5,
    e1,
    e2,
    e3,
    e4,
    e5,
    dandy_logo,
    left,
    right,
    facebook,
    instagram,
    tiktok,
    youtube,
    main_logo,
    sqr_logo,
    about_hero,
    mission,
    vission,
    logo_white,
    pricing_hero,
    priyantha_hero,
    priyantha_hero2,
    priyantha,
    gallery,
    contact,
    why1,
    why2,
    why3,
    why4,
    why5,
    why6,
    location_pin,
    telephone, email,
    t1,
    t2,
    t3,
    t4,
}

export default Image